export function getDutchLocaleEntries(): Record<string, string> {
  return {
    // for filter panel
    page: 'pagina',
    more: 'meer',
    to: 'tot',
    of: 'van',
    next: 'volgende',
    last: 'laatste',
    first: 'eerste',
    previous: 'vorige',
    loadingOoo: 'Laden...',

    // for set filter
    selectAll: 'Alles selecteren',
    searchOoo: 'Zoeken...',
    blanks: 'leeg',
    clearFilter: 'Filter leegmaken',
    aND: 'en',
    oR: 'of',

    // for number filter and text filter
    filterOoo: 'Filter...',
    applyFilter: 'Filter toepassen',

    // for number filter
    equals: 'gelijk aan',
    notEqual: 'niet gelijk aan',
    lessThan: 'kleiner dan',
    lessThanOrEqual: 'kleiner of gelijk',
    greaterThan: 'groter dan',
    greaterThanOrEqual: 'groter of gelijk',
    inRange: 'in bereik',

    // for text filter
    contains: 'bevat',
    notContains: 'bevat geen',
    startsWith: 'begint met',
    endsWith: 'eindigt met',

    // the header of the default group column
    group: 'Groep',

    // other
    noRowsToShow: 'Geen resultaten',

    // enterprise menu
    pinColumn: 'Kolom vastmaken',
    groupBy: 'Groeperen op',
    ungroupBy: 'Degroeperen op',
    resetColumns: 'Herstel kolommen',
    expandAll: 'Alles uitklappen',
    collapseAll: 'Alles inklappen',
    export: 'Exporteren',
    csvExport: 'Exporteren naar CSV',
    excelExport: 'Exporteren naar Excel',
  };
}
